import axios from "../../utils/axios";

// 运费设置管理
export function getList(query) {
    return axios({
        url: "expPriceManage/getList",
        method: "get",
        params: query
    });
}

// 运费设置详情
export function getPriceInfo(query) {
    return axios({
        url: "expPriceManage/getInfo",
        method: "get",
        params: query
    });
}

// 运费设置删除
export function deleteExpPrice(query) {
    return axios({
        url: "expPriceManage/delete",
        method: "get",
        params: query
    });
}

// 运费设置修改
export function updateExpPrice(data) {
    return axios({
        url: "expPriceManage/update",
        method: "post",
        data: data
    });
}

// 运费设置修改
export function addExpPrice(data) {
    return axios({
        url: "expPriceManage/update",
        method: "post",
        data: data
    });
}

// 查询分区
export function getSubArea(data) {
    return axios({
        url: "expPriceManage/getSubArea",
        method: "get",
        params: data
    });
}

